import React from 'react';

// Simple NLP emotion detector based on keywords
export const detectEmotion = (text) => {
  if (!text) return 'neutral';
  
  const lowerText = text.toLowerCase();
  
  // Check for impressed expressions
  if (
    lowerText.includes('impressive') ||
    lowerText.includes('excellent insight') ||
    lowerText.includes('brilliant') ||
    lowerText.includes('exceptional') ||
    lowerText.includes('outstanding') ||
    lowerText.includes('that\'s very astute') ||
    lowerText.includes('terrific') ||
    lowerText.includes('ingenious')
  ) {
    return 'impressed';
  }
  
  // Check for encouraging expressions
  if (
    lowerText.includes('you\'re on the right track') ||
    lowerText.includes('keep going') ||
    lowerText.includes('that\'s a good start') ||
    lowerText.includes('you\'re getting there') ||
    lowerText.includes('continue with that approach') ||
    lowerText.includes('i like where you\'re going') ||
    lowerText.includes('you\'re making progress') ||
    lowerText.includes('that\'s a good direction')
  ) {
    return 'encouraging';
  }
  
  // Check for surprised expressions
  if (
    lowerText.includes('wow') ||
    lowerText.includes('amazing') ||
    lowerText.includes('incredible') ||
    lowerText.includes('unexpected') ||
    lowerText.includes('surprising') ||
    lowerText.includes('shocked') ||
    lowerText.includes('astonish') ||
    lowerText.includes('!!')
  ) {
    return 'surprised';
  }
  
  // Check for happy expressions
  if (
    lowerText.includes('great') ||
    lowerText.includes('excellent') ||
    lowerText.includes('good job') ||
    lowerText.includes('well done') ||
    lowerText.includes('correct') ||
    lowerText.includes('perfect') ||
    lowerText.includes('happy') ||
    lowerText.includes(':)') ||
    lowerText.includes('😊')
  ) {
    return 'happy';
  }
  
  // Check for thinking expressions
  if (
    lowerText.includes('consider') ||
    lowerText.includes('think about') ||
    lowerText.includes('what if') ||
    lowerText.includes('perhaps') ||
    lowerText.includes('interesting') ||
    lowerText.includes('hmm') ||
    lowerText.includes('let me think') ||
    lowerText.includes('question')
  ) {
    return 'thinking';
  }
  
  // Check for concerned expressions
  if (
    lowerText.includes('not quite') ||
    lowerText.includes('incorrect') ||
    lowerText.includes('wrong') ||
    lowerText.includes('issue') ||
    lowerText.includes('problem') ||
    lowerText.includes('challenge') ||
    lowerText.includes('difficult') ||
    lowerText.includes('concern')
  ) {
    return 'concerned';
  }
  
  // Default to neutral
  return 'neutral';
};

// Calculate confidence score based on the number of matched keywords
export const getEmotionConfidence = (text, emotion) => {
  if (!text) return 0;
  
  const lowerText = text.toLowerCase();
  let matchCount = 0;
  
  const emotionKeywords = {
    impressed: ['impressive', 'excellent insight', 'brilliant', 'exceptional', 'outstanding', 'astute', 'terrific', 'ingenious'],
    encouraging: ['right track', 'keep going', 'good start', 'getting there', 'continue', 'like where you\'re going', 'making progress', 'good direction'],
    surprised: ['wow', 'amazing', 'incredible', 'unexpected', 'surprising', 'shocked', 'astonish'],
    happy: ['great', 'excellent', 'good job', 'well done', 'correct', 'perfect', 'happy'],
    thinking: ['consider', 'think about', 'what if', 'perhaps', 'interesting', 'hmm', 'let me think'],
    concerned: ['not quite', 'incorrect', 'wrong', 'issue', 'problem', 'challenge', 'difficult']
  };
  
  if (emotionKeywords[emotion]) {
    emotionKeywords[emotion].forEach(keyword => {
      if (lowerText.includes(keyword)) matchCount++;
    });
  }
  
  return matchCount > 0 ? Math.min(matchCount / 3, 1) : 0;
};

export default {
  detectEmotion,
  getEmotionConfidence
}; 